import { SiteNavigationController } from "./site-navigation.controller";

export class SiteNavigationComponent {
  controller: any = SiteNavigationController;
  templateUrl: string = "/html/components/site_navigation_header";
}

angular.module("BookingApp").component("siteNavigation", new SiteNavigationComponent());
